<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card v-if="fetchingBankList">
          <b-card-body>
            <h3 class="float-left">Fetching Data ...</h3>
          </b-card-body>
        </b-card>
        <b-card no-body v-else>
          <b-card-header>
            <h3 class="float-left"><i class='fa fa-trophy'></i> Bank Management (Manual Deposit)</h3>
          </b-card-header>
          <b-card-body >
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="bankList" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <template v-slot:cell(display)="data">
                <b-badge variant="success" v-if="data.item.display === 1">First Deposit</b-badge>
                <b-badge variant="primary" v-if="data.item.display === 0">Regular Deposit</b-badge>
              </template>
              <template v-slot:cell(action)="data" v-if="checkAccessPrivilege('Payment.ManualDeposit.UpdateBank')">
                <b-button variant="info" @click="updateBank(data.item)" ><i class="icons icon-pencil"></i></b-button>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(bankList)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <UpdateManualDepositBank :bankList="bankList" :showUpdateModal="showUpdateModal" :updateData="updateData" @cancelUpdate="cancelModal" @updateData="refreshData"/>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../events.js'
  import UpdateManualDepositBank from './UpdateManualDepositBank'
  
export default {
    name: 'manualDeposit-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        fetchingBankList: false,
        fields: [
          {key: 'receiptAccountId', label: 'Receipt AccountId'},
          {key: 'receiptBankAccount', label: 'Receipt Bank Account'},
          {key: 'receiptBankAccountName', label: 'Receipt Bank Account Name'},
          {key: 'bankCode', label: 'Bank Code'},
          {key: 'bankName', label: 'Bank Name'},
          {key: 'display', label: 'Status'},
          {key: 'action', label: 'Action'}
        ],
        currentPage: 1,
        perPage: 30,
        showUpdateModal: false,
        updateData: {},
        bankList: []
      }
    },
    components: {
      UpdateManualDepositBank
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      async getBankList () {
        try {
          this.fetchingBankList = true
          let { data } = await this.$http.get(this.API_ENDPOINT + '/payment/manual/deposit/getManualDepositBankList', { headers: { 'Content-Type': 'application/json' } })
          this.bankList = data.list
        } catch (err) {
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        } finally {
          this.fetchingBankList = false
        }
      },
      refreshData () {
        this.getBankList()
        this.cancelModal()
      },
      updateBank (data) {
        this.showUpdateModal = true
        this.updateData = data
      },
      cancelModal () {
        this.showUpdateModal = false
        this.updateData = {}
      },
      checkAccessPrivilege (module) {
        if (!module) return true
        return this.PRIVILEGE.includes(module)
      }
    },
    created () {
      this.getBankList()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/manualDeposit/ManualDepositTable.vue